import { connect } from 'react-redux';
import { IState } from '../../store';

import { BtiCommercialHouseData, IBtiCommercialHouseDataProps } from './index';

function mapStateToProps(state: IState): IBtiCommercialHouseDataProps {
  return {
    houseData: state.offerData.bti && state.offerData.bti.houseData || null,
    jkName: state.offerData.offer.category === 'newBuildingFlatSale' && state.offerData.newObject
      ? state.offerData.newObject.name
      : '',
    offer: state.offerData.offer,
    roomCount: state.offerData.offer.roomsCount || null,
  };
}

export const BtiCommercialHouseDataContainer =
  // tslint:disable-next-line:no-any
  connect<IBtiCommercialHouseDataProps, any, any>(mapStateToProps)(BtiCommercialHouseData);
